const validator = {
  getMessage: (field, params) => {
    const decimals = params[0] || 2
    return `O campo ${field} deve ser numérico e deve conter ${decimals} casas decimais (use vírgula ou ponto como separador decimal).`
  },
  validate: (value, params) => {
    if (!value) return true // Campo vazio é válido (deixa o required cuidar disso)

    const decimals = parseInt(params[0]) || 2

    // Normaliza o valor (substitui vírgula por ponto)
    const normalizedValue = value.toString().replace(',', '.')

    // Verifica se é um número válido
    if (isNaN(normalizedValue) || normalizedValue === '') {
      return false
    }

    const num = parseFloat(normalizedValue)

    // Verifica se é um número válido
    if (isNaN(num)) {
      return false
    }

    // Verifica o número de casas decimais
    const decimalPart = normalizedValue.split('.')[1]
    if (decimalPart && decimalPart.length > decimals) {
      return false
    }

    return true
  }
}

export default validator
